import React, { Component } from "react";
import { connect } from "react-redux";
import EmptyState from "../common/EmptyState";
import AdminBadge, { ROLE_ORDER, roleTone } from "./AdminBadge";

// Admins as lanyard ID badges, grouped by role.
export class Datatable extends Component {
  render() {
    const { myData, currentAdmin, startToggleModal, emptyText } = this.props;
    const canChange = !(currentAdmin && currentAdmin.status === "Partner");
    const admins = myData || [];

    if (admins.length === 0) {
      return <EmptyState>{emptyText || "No admins found."}</EmptyState>;
    }

    // Known roles first in a fixed order, then anything else.
    const roles = [
      ...ROLE_ORDER,
      ...Array.from(new Set(admins.map((a) => a.status || "No role"))).filter(
        (r) => !ROLE_ORDER.includes(r)
      ),
    ];

    let index = 0;
    return (
      <div className="kd-badge-groups">
        {roles.map((role) => {
          const group = admins.filter((a) => (a.status || "No role") === role);
          if (group.length === 0) return null;
          return (
            <section key={role} className={`kd-badge-group kd-st--${roleTone(role)}`}>
              <h3 className="kd-badge-group-head">
                <span className="kd-badge-group-dot" aria-hidden="true" />
                {role}
                <span className="kd-badge-group-count">{group.length}</span>
              </h3>
              <ul className="kd-badges">
                {group.map((admin) => (
                  <li key={admin.adminId}>
                    <AdminBadge
                      admin={admin}
                      index={index++}
                      canChange={canChange}
                      onChange={startToggleModal}
                    />
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentAdmin: state.admins.currentAdmin,
});

export default connect(mapStateToProps, null)(Datatable);
